<template>
  <div>
    <!--  header-->
    <TriangleHeader :title="$t(management.cat_title)"/>
  <loading v-if="loading"/>
  <div v-else>
    <div>
      <v-row
          :class="$vuetify.breakpoint.smAndDown?'mx-1':'mx-16'"
          class="mt-4  py-16">
        <v-col xl="4" lg="4" cols="12">
          <img  height="340" width="100%" :src="management.topics[0].photo_file" alt="">
        </v-col>
    <v-col  xl="8" lg="8" cols="12">
      <div class="mr-8">
        <h2 class="font-weight-bold">{{ management.topics[0].title }}</h2>
        <div v-html="management.topics[0].details"></div>
      </div>
    </v-col>
      </v-row>


    </div>
  </div>

  </div>
</template>

<script>
import TriangleHeader from "../../../components/triangle_header/TriangleHeader";
import {GET_MANAGEMENT} from "../../../store/aboutManagement/action_type";
import {mapState} from "vuex";

export default {
  name: "management",
  components: {TriangleHeader},
  data() {
    return {
      openDetails: false,
      selectedTab: 0,
      filters: [
        {
          id: 1,
          title: 'Customer Success Center'
        },
        {
          id: 2,
          title: 'Innovations'
        },
        {
          id: 3,
          title: 'Our factory'
        },
        {
          id: 4,
          title: 'About Ardakan'
        },
        {
          id: 5,
          title: 'Virtual visit'
        },
      ],
    }
  },
  created() {
    this.$store.dispatch(`aboutManagement/${GET_MANAGEMENT}`);
  },
  computed: {
    ...mapState({
      management: state => state.aboutManagement.management,
      loading:state => state.aboutManagement.loading,
    })
  }
}
</script>

<style scoped>
.detail {

  background: #f2c303 url("../../../assets/images/sunburst.png");
}

.detail-show {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 600px;
  animation: open-box 2s ease-in;
}


@keyframes open-box {
  from {
    height: 0
  }
  to {
    height: 600px
  }
}

@keyframes show {
  from {
    opacity: 0;
    height: 0
  }
  to {
    opacity: 1;
    height: 340px
  }
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 200px;
  background: #f2c303 url("../../../assets/images/sunburst.png");
}
.content-box{
  background: url("../../../assets/images/header_background.svg");
}

.faq-header-bottom-border {
  position: absolute;
  bottom: -22px;
  width: 100%;
}

.tab-item {
  cursor: pointer;
  height: 60px;
  width: 99%;
  font-weight: bold;
  font-size: 14px;
  margin: 8px 2px;
  background: #3b393a;
  color: #f2c303;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.selected-tab {
  cursor: pointer;
  height: 60px;
  width: 99%;
  font-weight: bold;
  font-size: 14px;
  margin: 8px 2px;
  background: #f2c303;
  color: #3b393a;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.selected-tab:hover {
  background: #f2c303;
  color: #3b393a;
}

.tab-item:hover {
  background: #1a1719;
}

.img-style {
  border-radius: 2px;
}

.boxes:hover > h2 {
  color: #F2C303;
  transition: color .4s;
}
</style>